import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withRouter } from 'react-router-dom';

import { firebase } from '../../firebase';

const withAuthorization = (authCondition) => (Component) => {
    class WithAuthorization extends React.Component {
        componentDidMount() {
            firebase.auth.onAuthStateChanged(authUser => {
                if (!authCondition(authUser)) {
                    this.props.history.push('/signin');
                }
            });
        }

        render() {
            return this.props.authUser ? <Component /> : <div> </div>;        }
    }

    const mapStateToProps = (state) => ({
        authUser: state.sessionState.authUser,
    });

    return compose(
        withRouter,
        connect(mapStateToProps),
    )(WithAuthorization);
};

export default withAuthorization;


// WEBPACK FOOTER //
// ./src/components/auth/withAuthorization.js